import React, { useState, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import DOMPurify from 'dompurify';
import { MarkdownStyles } from '../../../../../../../../../elements/ChatBox/MarkdownStyles';
import {
  UCPMessageContainer,
  MessageWrapper,
  MessageTimestamp,
  MessageFooter,
  CopyButton,
  MarkdownContent,
} from './UCPMessage.styled';

const UCPMessage = ({ messageItem, isTyping = false }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  
  const isUserMessage = messageItem.type === 'sent';
  
  // Sanitize message content
  const sanitizedMessage = DOMPurify.sanitize(messageItem.message || '', {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br', 'ul', 'ol', 'li', 'code', 'pre', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'blockquote', 'hr', 'img'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'class'],
  });

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(messageItem.message || '');
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  }, [messageItem.message]);

  // Custom table components for markdown
  const markdownComponents = {
    table: ({ children }) => (
      <div className="markdown-table-container">
        <table className="markdown-table">{children}</table>
      </div>
    ),
    thead: ({ children }) => <thead className="markdown-thead">{children}</thead>,
    tbody: ({ children }) => <tbody className="markdown-tbody">{children}</tbody>,
    tr: ({ children }) => <tr className="markdown-tr">{children}</tr>,
    th: ({ children }) => <th className="markdown-th">{children}</th>,
    td: ({ children }) => <td className="markdown-td">{children}</td>,
  };

  return (
    <>
      <MarkdownStyles />
      <UCPMessageContainer $isUser={isUserMessage}>
        <MessageWrapper $isUser={isUserMessage} $isTyping={isTyping}>
          {messageItem.time && (
            <MessageTimestamp>
              {messageItem.time}
            </MessageTimestamp>
          )}
          
          <MarkdownContent className={`markdown-content ${isTyping ? 'streaming-message' : ''}`}>
            <ReactMarkdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw, rehypeSanitize]}
              components={markdownComponents}
            >
              {sanitizedMessage}
            </ReactMarkdown>
          </MarkdownContent>

          {!isUserMessage && !isTyping && (
            <MessageFooter>
              <CopyButton onClick={handleCopy} $copied={copySuccess}>
                {copySuccess ? '✓ Copied' : 'Copy'}
              </CopyButton>
            </MessageFooter>
          )}
        </MessageWrapper>
      </UCPMessageContainer>
    </>
  );
};

export default UCPMessage;
